export const environment = {
  production: false,
  local: true,
  apiUrl: 'https://bo.pinup-antifraud.dev/v1',
  devEnvUrl: 'https://a.pinup-antifraud.dev',
  prodEnvUrl: 'https://a.pinup-antifraud.com',
  faviconPath: 'assets/favicon.dev.svg',
  useMock: true,
  transactionsDefaultCols: [
    'account_currency',
    'account_date_of_birth',
    'account_email',
    'account_first_name',
    'account_gender',
    'account_geo',
    'account_is_test',
    'account_last_name',
    'account_login',
    'account_project',
    'account_stream_id',
    'account_telephone',
    'customer_event_type',
    'device_id',
    'event_id',
    'event_time',
    'input_ip_address',
    'line_of_business',
    'request_id',
    'review_status',
    'score',
    'session_id',
    'web_session_id',
  ],
  defaultLang: 'en',
  notificationsLiveTime: 5000,
};
